(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ShopperSummaryCtrl', ShopperSummaryCtrl);

  // @ngInject
  function ShopperSummaryCtrl(storeKeys, filters, DateUtil, ConsumerChart, TransactionReports, StandardReports,
                              Callout, SectionConfig, UserCohort) {
    var vm = this;
    var detailLevel = filters.pathParams.detailLevel;

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.transactionColorSwatch = StandardReports.getColorSwatches();

    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});

    vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };


    var spu = SectionConfig.spu;
    var mau = SectionConfig.mauSummary;
    var monthlySessions = SectionConfig.monthlySessions;

    vm.spuSection = Callout.labelValueConfig(spu);
    vm.sessionsPerUserChartData = function (sessionsPerUser) {
      vm.sessionsPerUserLift = StandardReports.findInSummary(sessionsPerUser.summary, 'SessionPerUsersLift', UserCohort.tf.value);

      return sessionsPerUser;
    };

    vm.mauSection = Callout.labelValueConfig(mau);
    vm.monthlyActiveUserChartData = function (monthlyUsers) {
      vm.tfAdoption = StandardReports.findInSummary(monthlyUsers.summary, 'TFAdoption', UserCohort.tf.value);

      return monthlyUsers;
    };

    vm.monthlySessionSection = Callout.labelValueConfig(monthlySessions);
    vm.monthlySessionChartData = function (monthlySessions) {
      return monthlySessions;
    };

  }
  })();
